const defaultProps = {
  rounded: 4,
  multiline: true,
  numberOfLines: 2,
  px: 4,
  py: 2,
};

export default { defaultProps };
